module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-707-min.cdc982a9.jpg";